import React, { FC, useEffect } from "react";
import StartRating from "components/StartRating/StartRating";
import { Link, useHistory } from "react-router-dom";
import BtnLikeIcon from "components/BtnLikeIcon/BtnLikeIcon";
import SaleOffBadge from "components/SaleOffBadge/SaleOffBadge";
import Badge from "shared/Badge/Badge";
import NcImage from "shared/NcImage/NcImage";
import { ManyItem } from "types/interfaces";
import toRupiah from "utils/toRupiah";
import { useDispatch, useSelector } from "react-redux";
import { likedProduct } from "actions/productActions";
import { RootState } from "store";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { updateListing } from "actions/addListingActions";

export interface CarCardProps {
  className?: string;
  data: ManyItem;
  size?: "default" | "small";
  promotion?: boolean;
  listing?: boolean;
  handleDelete?: (id: string) => void;
}

const ItemCard: FC<CarCardProps> = ({
  size = "default",
  className = "",
  data,
  promotion = true,
  listing = false,
  handleDelete = () => {},
}) => {
  const { _id, images, name, address, price, status, thumbnail } = data;
  const { likedProducts } = useSelector(
    (state: RootState) => state.likedProduct
  );
  const { userInfo } = useSelector((state: RootState) => state.userInfo);
  const { loading, redirect } = useSelector(
    (state: RootState) => state.productUpload
  );
  const history = useHistory();

  const dispatch = useDispatch();

  const handleLike = () => {
    dispatch(likedProduct(_id));
  };

  const handleUpdate = () => {
    dispatch(updateListing(_id));
  };

  useEffect(() => {
    if (redirect) history.push("/add-listing-1");
  }, [redirect]);

  const renderSliderGallery = () => {
    return (
      <div className="relative w-full rounded-2xl overflow-hidden">
        <div className="aspect-w-16 aspect-h-9 ">
          <NcImage
            containerClassName="flex items-center justify-center"
            className="w-full"
            src={thumbnail ?? images[0]}
          />
        </div>
        {userInfo && (
          <BtnLikeIcon
            isLiked={
              likedProducts &&
              likedProducts.find((value: string) => {
                return value === _id;
              })
                ? true
                : false
            }
            className="absolute right-3 top-3 z-20"
            onClick={handleLike}
          />
        )}
        {status.saleOff > 0 && (
          <SaleOffBadge
            className="absolute left-3 top-3"
            desc={status.saleOff}
          />
        )}
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className={size === "default" ? "p-5  space-y-4" : "p-3  space-y-2"}>
        <div className="space-y-2">
          <div className="flex items-center space-x-2">
            {status.isAds && <Badge name="ADS" color="green" />}
            <h2
              className={`  capitalize ${
                size === "default"
                  ? "text-xl font-semibold"
                  : "text-base font-medium"
              }`}
            >
              <span className="line-clamp-1">{name}</span>
            </h2>
          </div>
          <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2">
            <span>
              {address.kecamatan.name} / {address.kabupaten.name}
            </span>
          </div>
        </div>
        <div className="w-14  border-b border-neutral-100 dark:border-neutral-800"></div>
        <div className="flex justify-between items-center">
          <span className="text-base font-semibold">
            Rp {toRupiah(price)}
            {` `}
            {size === "default" && (
              <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                / hari
              </span>
            )}
          </span>
          <StartRating
            reviewCount={status.reviews.length}
            point={status.rating}
          />
        </div>
        {listing && renderListing()}
      </div>
    );
  };

  /**
   * render listing displays edit and delete button for user listed product
   * @returns
   */
  const renderListing = () => {
    return (
      <div
        className="grid grid-cols-2 gap-x-3 z-20"
        onClick={(e) => e.preventDefault()}
      >
        <ButtonPrimary onClick={handleUpdate} loading={loading}>
          Ubah
        </ButtonPrimary>
        <ButtonSecondary onClick={() => handleDelete(_id)}>
          Hapus
        </ButtonSecondary>
      </div>
    );
  };

  return (
    <div
      className={`nc-CarCard group relative border border-neutral-200 dark:border-neutral-700 rounded-3xl overflow-hidden hover:shadow-xl transition-shadow bg-white dark:bg-neutral-900 ${className}`}
      data-nc-id="CarCard"
    >
      <Link to={`/listing/${_id}`} className="flex flex-col">
        {renderSliderGallery()}
        {renderContent()}
      </Link>
    </div>
  );
};

export default ItemCard;
